import { createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";

const newsHeaders = {
    'X-BingApis-SDK': 'true',
        'X-RapidAPI-Key': '4a5490110bmshd03c6c515683777p1e5d6fjsnf6de30eeccaf',
        'X-RapidAPI-Host': 'bing-news-search1.p.rapidapi.com'
}

const baseUrl = 'https://bing-news-search1.p.rapidapi.com'

const createRequest = (url) => ({url, headers: newsHeaders})

export const newsApi = createApi({
    reducerPath: 'newsApi',
    baseQuery: fetchBaseQuery({ baseUrl }),
    endpoints: (builder) => ({
        getNews: builder.query({
            query: ({newsCategory, count}) => createRequest(`/news/search?q=${newsCategory}&safeSearch=Off&textFormat=Raw&freshness=Day&count=${count}`)
        })
    })
})

export const { useGetNewsQuery } = newsApi
